import * as graphql from '@treams/treams-network';

export function useWorkspaceConnector(): graphql.ConnectorType | null {
	const { data } = graphql.useWorkspaceConnectorQuery({
		nextFetchPolicy: 'cache-first',
	});

	return data?.viewer.workspace.connector?.type || null;
}
